<template>
	<div class="container_page">
		<!-- <div class="filter_box">
      <div class="flex">
        <a-button class="mr12" type="primary" @click="toAdd">新增</a-button>
      </div>
      <span></span>
    </div> -->
		<a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
			:loading="loading">
			<template slot="bankIcon" slot-scope="text, record">
				<div v-if="record.bankIcon !== null">
					<img :src="record.bankIcon" alt="" style="width: 100px;height: 100px" @click="toSeeImg(record)" />
				</div>
				<div v-else>-</div>
			</template>
			<template slot="action" slot-scope="text, record">
				<div class="flex_center">
					<a-button type="link" @click="toEdit(record)">编辑</a-button>
					<!-- <a-button type="link" @click="toDelete(record)">删除</a-button> -->
				</div>
			</template>
		</a-table>
		<a-modal :visible="imgModel.flag" width="880px" :closable="false" maskClosable :destroyOnClose="true">
			<template slot="footer">
				<a-button @click="imgModel.flag = false">关闭</a-button>
			</template>
			<span>
				<img :src="imgModel.url" alt="" style="width: 800px;height: 296px" />
			</span>
		</a-modal>
		<a-modal :title="tipsModel.title" :visible="tipsModel.flag" @ok="tipsModel.onOk"
			@cancel="tipsModel.flag = false">
			<span>
				{{ tipsModel.content }}
			</span>
		</a-modal>
		<a-modal :title="editModel.title" :visible="editModel.flag" width="1200px" @ok="editModel.onOk"
			@cancel="editModel.flag = false">
			<a-form-model :model="editModel" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-form-model-item label="内容">
					<quill-editor v-model="editModel.protocoContent" ref="myQuillEditor"
						:options="editorOption"></quill-editor>
				</a-form-model-item>

			</a-form-model>


		</a-modal>
	</div>
</template>

<script>
	import {
		getProtocolsApi,
		setProtocolsApi,
		detailProtocolsApi,
		getOssAuth,
	} from "../../api/index";
	import {
		quillEditor
	} from 'vue-quill-editor'
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css' // 使用 snow 主题
	// import 'quill/dist/quill.bubble.css' // 使用 bubble 主题
	export default {
		name: "settingContentList",
		components: {
			quillEditor
		},
		data() {
			return {

				editorOption: {

				},
				columns: [{
						title: "ID",
						key: "protocolId",
						dataIndex: "protocolId",
					},
					{
						title: "标题",
						key: "title",
						dataIndex: "title",
					},
					// {
					//   title: "银行Icon",
					//   key: "bankIcon",
					//   scopedSlots: { customRender: "bankIcon" }
					// },
					// {
					//   title: "银行名称",
					//   dataIndex: "bankName",
					//   key: "bankName",
					// },
					// {
					//   title: "序号",
					//   dataIndex: "sort",
					//   key: "sort",
					// },
					// {
					//   title: "创建日期",
					//   dataIndex: "createTime",
					//   key: "createTime",
					// },
					{
						title: "操作",
						key: "action",
						width: 300,
						scopedSlots: {
							customRender: "action"
						},
					},
				],
				tableData: [],
				pageInfo: {
					pageSize: 20,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				imgModel: {
					flag: false,
					url: "",
				},
				tipsModel: {
					flag: false,
					title: "",
					content: "",
					countryId: '',
					onOk: () => {},
				},
				editModel: {
					flag: false,
					title: "",
					bankId: 0,
					bankName: '',
					bankIcon: "",
					sort: "",
					onOk: () => {},
				},
				formState: {
					"bankIcon": "", //卡片图标
					"name": "", //卡片名称
					"sort": 1 //序号
				},
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 18
				},
			};
		},
		created() {},
		activated() {},
		mounted() {
			this.getData(1);
		},
		methods: {
			changePage(page) {
				this.pageInfo.current = page.current;
				this.getData(this.pageInfo.current);
			},
			getData(page = 1) {
				this.pageInfo.current = page;
				if (this.loading) {
					return;
				}
				this.loading = true;
				getProtocolsApi()
					.then((res) => {
						if (res.resultStatus) {
							this.tableData = res.resultData.dataList || [];
							this.pageInfo.total = res.resultData.totalNum || 0;

						} else {
							this.tableData = [];
							this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			// toAdd() {
			//   this.editModel = {
			//     flag: true,
			//     title: "新增",
			//     bankId:0,
			//     bankName: '',
			//     bankIcon: "",
			//     sort:this.tableData.length + 1,
			//     onOk: this.sureEdit,
			//   };
			// },
			toEdit(data) {
				this.editModel = {
					flag: true,
					title: "编辑",
					newTitle: data.title,
					protocolId: data.protocolId,
					protocoContent: data.protocoContent,
					onOk: this.sureEdit,
				};
			},
			confirm() {

			},
			sureEdit() {
				setProtocolsApi({
						protocolId: this.editModel.protocolId,
						protocoContent: this.editModel.protocoContent,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success(
								this.editModel.bankId ? "编辑成功" : "编辑成功"
							);
							this.editModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.getData()
					})
			},
			toDelete(data) {
				this.tipsModel = {
					flag: true,
					title: "删除卡片图标",
					content: "确认要卡片图标吗？",
					bankId: data.bankId,
					onOk: this.sureDelete,
				};
			},
			toSeeImg(data) {
				this.imgModel = {
					flag: true,
					url: data.bankIcon,
				};
			},
			sureDelete() {
				if (this.loading) {
					return;
				}
				this.loading = true;
				deleteBanksApi({
						bankId: this.tipsModel.bankId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success("删除成功");
							this.tipsModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.loading = false;
						this.getData(1);
					});
			},
			// 上传文件
			handleUpdataFile(e) {
				if (e.target.files.length) {
					const file = e.target.files[0];
					console.log("file", file);
					if (file) {
						const form = new FormData();
						form.append("file", file);
						console.log("form", form);
						getOssAuth(form).then((res) => {
							if (res.resultStatus) {
								this.editModel.bankIcon = res.resultData.fileLink;
							}
						});
					}
				}
			},
		},
	};
</script>

<style lang="less">
	.container_page {
		padding: 20px;
		background: #ffffff;

		.filter_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 12px;
		}

		.mr12 {
			margin-right: 12px;
		}
	}
</style>